// Copyright 2026, Auxilio Technologies LLC

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ThemeState {
  isDarkMode: boolean;
  toggleTheme: () => void;
  setDarkMode: (isDark: boolean) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      isDarkMode: false,

      toggleTheme: () =>
        set((state) => ({ isDarkMode: !state.isDarkMode })),

      setDarkMode: (isDark) =>
        set({ isDarkMode: isDark }),
    }),
    {
      name: 'auxilio-logistics-theme',
    }
  )
);
